import { render } from "./LightningTestPage.vue?vue&type=template&id=5f4a448a&scoped=true"
import script from "./LightningTestPage.vue?vue&type=script&lang=js"
export * from "./LightningTestPage.vue?vue&type=script&lang=js"

import "./LightningTestPage.vue?vue&type=style&index=0&id=5f4a448a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4a448a"]])

export default __exports__